import { AbsoluteRouteContext } from './context';
import { AbsoluteRouteDetectorProvider } from './provider';
export * from './utils';

export const AbsoluteRouteDetector = {
  Provider: AbsoluteRouteDetectorProvider,
  Context: AbsoluteRouteContext,
};
